import { trigger, state, style, animate, transition, keyframes, AnimationTriggerMetadata } from '@angular/animations';

export const showSourceTree: AnimationTriggerMetadata = trigger('showSourceTree', [
	state ('true', style({height: '*'})),
	state ('false', style({height: 0})),

	transition ('true => false', animate('.3s ease-in-out')),
	transition ('false => true', animate('.3s ease-in-out'))
])